import React from 'react';

export default ({ color, style }) => (
  <div
    style={{
      color: 'white',
      position: 'relative',
      width: '8px',
      height: '8px',
      paddingLeft: '0.3em',
      borderRadius: '8px',
      top: '-14px',
      left: '-6px',
      backgroundColor: color || '#ff4081',
      display: 'inline-block',
      ...style,
    }}
  />
);



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/redDot.jsx